// extracted by mini-css-extract-plugin
export default {"skipNavOption":"App_skipNavOption__SOfGx","mainContent":"App_mainContent__qBoGT","innerContent":"App_innerContent__0qf4K","toast":"App_toast__t-Iuz"};